/**
 * Product Tabs Web Component
 * Desktop tab switching with ARIA keyboard navigation (Arrow, Home, End).
 * Mobile accordion uses native <details>/<summary> — no JS needed.
 */
import { ABBaseComponent, defineComponent } from './ab-base-component.js';

class ABProductTabs extends ABBaseComponent {
  connectedCallback() {
    const tabNav = this.$('.ab-product-tabs__nav');
    if (tabNav) {
      tabNav.addEventListener('click', this.onTabClick.bind(this));
      tabNav.addEventListener('keydown', this.onKeydown.bind(this));
    }
  }

  onTabClick(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    this.activateTab(tab);
  }

  onKeydown(event) {
    const tabs = Array.from(this.$$('[role="tab"]'));
    const current = tabs.indexOf(event.target);
    if (current === -1) return;

    let next;
    if (event.key === 'ArrowRight') {
      next = (current + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
      next = (current - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    tabs[next].focus();
    this.activateTab(tabs[next]);
  }

  activateTab(tab) {
    // Deactivate all tabs
    this.$$('[role="tab"]').forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    // Hide all panels
    this.$$('[role="tabpanel"]').forEach(p => p.hidden = true);

    // Activate selected tab
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    // Show corresponding panel
    const panelId = tab.getAttribute('aria-controls');
    const panel = this.$(`#${panelId}`);
    if (panel) panel.hidden = false;
  }
}

defineComponent('ab-product-tabs', ABProductTabs);
